import type React from 'react';

import type { StarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { PostPreview } from '#src/app/pages/starterDashboardV2/shared/components';
import type { PostPreviewSizes } from '#src/app/pages/starterDashboardV2/shared/components';
import type { EnrichedReadyToSharePlatformPostV2 } from '#src/app/shared/api/readyToShare';

import { EMPTY_SHARING_RESOURCE } from '../constants';

type Props = {
	postTypeName: EnrichedReadyToSharePlatformPostV2['__typename'];
	size: PostPreviewSizes;
	petition: StarterDashboardV2PageData['petition'];
};

export const PostPreviewCardSkeleton: React.FC<Props> = (props) => {
	const { postTypeName, size, petition } = props;

	return (
		<section
			className="flex gap-3"
			data-testid={`${postTypeName}-post-card-skeleton`}
			data-qa={`${postTypeName}-post-card-skeleton`}
			aria-label={`${postTypeName} post card skeleton`}
		>
			<PostPreview
				variant={postTypeName}
				sharingResource={EMPTY_SHARING_RESOURCE}
				size={size}
				loading
				showPlatformIcon
				petition={petition}
				disabled={false}
			/>
		</section>
	);
};
